module.exports = __webpack_public_path__ + "img/nes2.ce885001.png";